import themeVariables from "@Theme/exportColor.module.scss";

export default ({
  tickFill = themeVariables.primary4,
  homeFill = themeVariables.primary1,
  width = 48,
  height = 39,
}) => (
  <svg width={width} height={height} viewBox="0 0 48 39" fill={tickFill}>
    <g id="Frame" clipPath="url(#clip0_10841_15248)">
      <path
        id="Vector"
        d="M26.4033 27.8968C26.4033 21.9682 31.2408 17.1582 37.2033 17.1582C43.1658 17.1582 48.0033 21.9682 48.0033 27.8968C48.0033 33.8255 43.1658 38.6355 37.2033 38.6355C31.2408 38.6355 26.4033 33.8255 26.4033 27.8968ZM42.2508 26.3532C42.7233 25.8908 42.7233 25.1302 42.2508 24.6678C41.7858 24.198 41.0208 24.198 40.5558 24.6678L36.0033 29.1944L33.8508 27.0542C33.3858 26.5843 32.6208 26.5843 32.1558 27.0542C31.6833 27.5165 31.6833 28.2772 32.1558 28.7395L35.1558 31.7225C35.6208 32.1923 36.3858 32.1923 36.8508 31.7225L42.2508 26.3532Z"
        fill={tickFill}
      />
      <path
        id="Vector_2"
        d="M37.2 14.7723C30.315 14.7723 24.66 20.0148 24.0525 26.7041H24H19.2C17.8725 26.7041 16.8 27.7705 16.8 29.0905V35.653C16.8 37.301 15.4575 38.6359 13.8 38.6359H9.6075C9.495 38.6359 9.3825 38.6285 9.27 38.621C9.18 38.6285 9.09 38.6359 9 38.6359H7.8C6.14325 38.6359 4.8 37.301 4.8 35.653V27.3007C4.8 27.2336 4.80225 27.159 4.80675 27.0919V21.9015H2.40375C1.0515 21.9015 0 20.8501 0 19.5077C0 18.8366 0.2253 18.24 0.75075 17.718L19.98 1.05189C20.505 0.528825 21.105 0.454102 21.63 0.454102C22.155 0.454102 22.755 0.603548 23.2125 0.977163L39.1575 14.914C38.52 14.8245 37.8675 14.7723 37.2 14.7723Z"
        fill={homeFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_10841_15248">
        <rect width={48} height={38.1818} fill="white" transform="translate(0 0.454102)" />
      </clipPath>
    </defs>
  </svg>
);
